import { onValue, ref } from "firebase/database";
import { db } from "../../../../firebase";

export const BookingObserver = (idRider, callback, onError = () => {}) => {
  try {
    const dbPath = `BookingBusiness`;
    const dbRef = ref(db, dbPath);

    const unsubscribe = onValue(
      dbRef,
      (snapshot) => {
        const resp = snapshot.val();
        let offerList = [];
        if (resp != null) {
          offerList = Object.entries(resp).map(([firebaseKey, booking]) => ({ ...booking, firebaseKey, uuid: booking.uuid || firebaseKey })).filter(
            (offer) =>
              Number(idRider) === Number(offer.client) &&
              Number(offer.booking_type) === 1
          );
        }
        callback(offerList); // Pasar los resultados a través del callback
      },
      (error) => {
        onError(error);
      }
    );

    return unsubscribe; // Devuelve la función de desuscripción
  } catch (error) {
    onError(error);
  }
};
